module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 16,
      "xl": 16
    }
  }, [_c('div', {
    staticStyle: {
      "color": "transparent"
    }
  }, [_vm._v("占位符")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 8,
      "xl": 8
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "login-form",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请用飞书扫码登录")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login_container"
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c7784b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 1105
// module chunks = 38